import { FC } from 'react'

type Props = {
  text?: string
}

const ErrorDrawerTitle: FC<Props> = ({ text = 'Ошибка' }) => {
  return <span>{text}</span>
}

export { ErrorDrawerTitle }
